import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';
import './style.scss';

import { Col, Form } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import AdditionalContacts from './AdditionalContacts';
import AdditionalContactsComp from './AdditionalContacts';
import ChildComponent from './AdditionalContacts';
import Input from '../../../text-field/index';
import ParentComponent from './AdditionalContacts';
import SalesForceCheckBox from '../../Delivery-card page/salesForceCheckbox';
import StepButton from '@pages/userComponents/Step-Button/StepButton';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { copy } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { images } from 'src/assets/img/index.js';
import { v4 as uuidv4 } from 'uuid';

// import SalesForceCheckBox from '../Delivery-card page/salesForceCheckbox';

// import '../userStyle.scss';

const ContactInfoPresentational = ({ navigateDisabled, contacts, payrollObjProp, hrObjProp, additionalContacts, handleSubmit, savingData }) => {
	// console.log('payrollObjProp, hrObjProp', payrollObjProp, hrObjProp);
	const history = useHistory();
	const [payrollObj, setPayrollObj] = useState({
		payrollName: '',
		payrollMobile: '',
		payrollLandline: '',
		payrollEmail: '',
	});
	const [hrObj, setHrObj] = useState({
		hrName: '',
		hrMobile: '',
		hrLandline: '',
		hrEmail: '',
	});

	useEffect(() => {
		setPayrollObj(payrollObjProp);
	}, [payrollObjProp]);

	useEffect(() => {
		setHrObj(hrObjProp);
	}, [hrObjProp]);

	useEffect(() => {
		setAdditionalDocuments(additionalContacts);
	}, [additionalContacts]);

	// const [payrollName, setPayrollName] = useState('');
	// const [payrollMobile, setPayrollMobile] = useState('');
	// const [payrollLandline, setPayrollLandline] = useState('');
	// const [payrollEmail, setPayrollEmail] = useState('');
	// const [hrName, setHrName] = useState('');
	// const [hrMobile, setHrMobile] = useState('');
	// const [hrLandline, setHrLandline] = useState('');
	// const [hrEmail, setHrEmail] = useState('');
	const [count, setCount] = useState(0);
	const [autoFilled, setAutoFilled] = useState(false);
	const [allow, setAllow] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [additionalDocuments, setAdditionalDocuments] = useState(additionalContacts);

	const handlePayroll = (key, value) => {
		setPayrollObj({
			...payrollObj,
			[key]: value,
		});
	};

	const handleHr = (key, value) => {
		setHrObj({
			...hrObj,
			[key]: value,
		});
	};

	const [errorMsgList, setErrorMsgList] = useState({
		payrolleNameerr: '',
		payrollMobilerr: '',
		payrollLandlineerr: '',
		payRollEmailerr: '',
		hrNameerr: '',
		hrMobileerr: '',
		hrLandlineer: '',
		hrEmailerr: '',
	});

	let regEmail =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const onFinish = () => {
		// && hrName && hrMobile && hrEmail
		// console.log('onfinish', allow);
		// handleSubmit(payrollObj, hrObj, additionalDocuments);
		// if (payrollName && payrollMobile && payrollEmail && hrName && hrMobile && hrEmail && allow) {
		// 	navigateDisabled?.(false);
		// } else {
		// 	navigateDisabled?.(true);
		// }
	};

	useEffect(() => {
		let preNum = payrollObj.x?.length > 5 && payrollObj.payrollLandline.substring(0, 5);
		if (payrollLandline?.length && (payrollObj.payrollLandline?.length !== 13 || (preNum.length > 0 && preNum !== '00971'))) {
			setErrorMsgList((prevState) => {
				return { ...prevState, payrollLandlineerr: 'Landline number must be 13 digits and should start with 00971.' };
			});
		} else {
			setErrorMsgList((prevState) => {
				return { ...prevState, payrollLandlineerr: '' };
			});
		}
	}, [payrollObj]);

	const { payrollName, payrollMobile, payrollLandline, payrollEmail } = payrollObj;

	const { hrEmail, hrName, hrMobile, hrLandline } = hrObj;

	const validateMessages = (changeValue, allValue) => {
		if (allValue.mobileNumber && allValue.mobileNumber.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.Landline && allValue.Landline.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.hrMobileNumber && allValue.hrMobileNumber.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.hrLandline && allValue.hrLandline.replace(/[^0-9]/g, '')?.length !== 8) {
			setAllow(false);
		} else if (allValue.Email && !regEmail.test(allValue.Email)) {
			setAllow(false);
		} else if (allValue.hrEmail && !regEmail.test(allValue.hrEmail)) {
			console.log('inisde hremail1');
			setAllow(false);
		} else {
			console.log('inisde hremail2');
			setAllow(true);
		}
	};

	const copyMainPayRollDetails = (value) => {
		if (value === true) {
			setErrorMsgList((prevState) => {
				return {
					...prevState,
					hrNameerr: errorMsgList.payrolleNameerr,
					hrMobileerr: errorMsgList.payrollMobilerr,
					hrLandlineer: errorMsgList.payrollLandlineerr,
					hrEmailerr: errorMsgList.payRollEmailerr,
				};
			});
			// setHrName(payrollName);
			// setHrMobile(payrollMobile);
			// setHrLandline(payrollLandline);
			// setHrEmail(payrollEmail);
			setHrObj({
				hrName: payrollName,
				hrMobile: payrollMobile,
				hrLandline: payrollLandline,
				hrEmail: payrollEmail,
			});
			setAutoFilled(true);
			setAllow(payrollName && payrollMobile && payrollEmail ? true : false);
		} else {
			setHrObj({
				hrName: '',
				hrMobile: '',
				hrLandline: '',
				hrEmail: '',
			});
			setAutoFilled(false);
			setAllow(false);
		}
		onFinish();
	};

	const validateForm = (e) => {
		if (e.target.name == 'mobileNumber') {
			if (payrollMobile?.length > 8 && payrollMobile?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollMobilerr: 'Mobile Number must be within 8 digits' };
				});
			} else if (payrollMobile?.length < 8 && payrollMobile?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollMobilerr: 'Mobile Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollMobilerr: '' };
				});
			}
		}

		if (e.target.name == 'Landline') {
			let preNum = payrollLandline?.length > 5 && payrollLandline.substring(0, 5);
			let preNumVal = e.target.value?.length > 5 && e.target.value.substring(0, 5);
			if (payrollLandline?.length && (payrollLandline?.length !== 13 || (preNum.length > 0 && preNum !== '00971'))) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollLandlineerr: 'Landline number must be 13 digits and should start with 00971.' };
				});
			} else if (e.target.value?.length && (e.target.value?.length !== 13 || (preNumVal.length > 0 && preNumVal !== '00971'))) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollLandlineerr: 'Landline number must be 13 digits and should start with 00971.' };
				});
			}
			// else if (payrollLandline?.length < 13 && payrollLandline?.length !== 0) {
			// 	setErrorMsgList((prevState) => {
			// 		return { ...prevState, payrollLandlineerr: 'Landline Number must be not less than 8 digits' };
			// 	});
			// }
			else {
				setErrorMsgList((prevState) => {
					return { ...prevState, payrollLandlineerr: '' };
				});
			}
		}

		if (e.target.name == 'payrollEmail') {
			console.log('testingggg', payrollEmail?.length !== undefined);
			if (!regEmail.test(payrollEmail) && payrollEmail?.length !== undefined) {
				setErrorMsgList((prevState) => {
					return { ...prevState, payRollEmailerr: 'Email not Valid' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, payRollEmailerr: '' };
				});
			}
		}
		if (e.target.name == 'hrEmail') {
			if (!regEmail.test(hrEmail) && hrEmail?.length !== undefined) {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrEmailerr: 'Email is not Valid' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrEmailerr: '' };
				});
			}
		}
		if (e.target.name == 'hrMobileNumber') {
			if (hrMobile?.length > 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrMobileerr: 'Mobile Number must be within 8 digits' };
				});
			} else if (hrMobile?.length < 8) {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrMobileerr: 'Mobile Number must be not  less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrMobileerr: '' };
				});
			}
		}

		if (e.target.name == 'hrLandline') {
			if (hrLandline?.length > 8 && hrLandline?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrLandlineer: 'Landline Number must be within 8 digits' };
				});
			} else if (hrLandline?.length < 8 && hrLandline?.length !== 0) {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrLandlineer: 'Landline Number must be not less than 8 digits' };
				});
			} else {
				setErrorMsgList((prevState) => {
					return { ...prevState, hrLandlineer: '' };
				});
			}
		}
	};

	const handleAddDocuments = () => {
		const index = uuidv4();
		setAdditionalDocuments([
			...additionalDocuments,
			{ index, hrNameProp: ``, hrMobileProp: '', hrLandlineProp: '', hrEmailProp: '', contactType: 'Additional', contactId: null },
		]);
	};

	const handleValueChange = (index, key, value) => {
		let additionalDocumentsTemp = additionalDocuments.map((data) => {
			if (data.index === index) {
				return {
					...data,
					[key]: value,
				};
			} else return data;
		});
		setAdditionalDocuments([...additionalDocumentsTemp]);
	};

	const removeAdditionalDocuments = (index) => {
		let additionalDocumentsTemp = additionalDocuments.filter((data) => data.index !== index);
		setAdditionalDocuments([...additionalDocumentsTemp]);
	};

	const isPayrollContactsValid = !!(
		payrollObj?.payrollName &&
		payrollObj?.payrollMobile?.length === 8 &&
		payrollObj.payrollEmail &&
		regEmail.test(payrollEmail)
	);
	const isHrContactsValid = !!(hrObj?.hrName && hrObj?.hrMobile?.length === 8 && hrObj.hrEmail && regEmail.test(hrEmail));

	const isAdditionalContactsValid = useMemo(
		() =>
			additionalDocuments.filter(
				(data) =>
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
						data.hrEmailProp.toLowerCase()
					) &&
					data?.hrMobileProp.length === 8 &&
					data?.hrNameProp
			).length === additionalDocuments.length,
		[additionalDocuments]
	);
	return (
		<>
			<Col className="contact-info">
				<div className="headercontainer ">
					<TextComponent className="heading_2_text">Main Payroll Contact</TextComponent>

					<TextComponent className="text2" style={{ marginTop: '20px' }}>
						<p>Will receive login details for the Edenred Payroll Portal.</p>
					</TextComponent>
				</div>
				<Form
					initialValues={{
						payrollName: payrollName?.toString(),
						payrollMobile,
						payrollLandline,
						payrollEmail,
						hrName,
						hrMobile,
						hrLandline,
						hrEmail,
					}}
					onFinish={onFinish}
					className="contactInfoFormWrapper"
					onValuesChange={validateMessages}>
					<Form.Item
						name="payrollName"
						validateTrigger="onBlur"
						rules={[
							{
								required: true,
								message: '',
							},
						]}>
						<Input
							name="payrollName"
							type="text"
							onBlur={validateForm}
							maxLength={100}
							labels={
								<span>
									Name <text style={{ color: 'red' }}>*</text>
								</span>
							}
							value={payrollName}
							onChange={(e) => {
								handlePayroll('payrollName', e.target.value.replace(/[^A-Za-z ]/gi, ''));
								autoFilled && handleHr('hrName', e.target.value.replace(/[^A-Za-z ]/gi, ''));
							}}
						/>
						<div>
							<TextComponent className="errorText">{errorMsgList.payrolleNameerr}</TextComponent>
						</div>
					</Form.Item>
					<Form.Item
						type="number"
						name="mobileNumber"
						className="mobileNumberClass"
						value={(payrollMobile && payrollMobile.length) === 14 ? payrollMobile && payrollMobile.substring(6) : ''}
						validateTrigger="onChange"
						rules={[
							{
								required: true,
								message: '',
							},
						]}>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<div style={{ display: 'flex', flexDirection: 'row' }}>
								<div className="country_container">
									<img className="countryFlag" src={images.UAE} />
									<div className="countrycode" style={{ width: 'max-content', paddingRight: 20 }}>
										<TextComponent className="contact_no_text">+971 5</TextComponent>
									</div>
								</div>
								<div className="contact_container" style={{ width: '-webkit-fill-available' }}>
									<div className="global_input_Container">
										<Input
											name="mobileNumber"
											maxLength={8}
											type="text"
											onBlur={validateForm}
											labels={
												<span>
													Mobile Number <text style={{ color: 'red' }}>*</text>
												</span>
											}
											style={{ width: '300px !important' }}
											value={payrollMobile}
											// onChange={(e) => setPayrollMobile(e.target.value.replace(/[^0-9]/g, ''))}
											onChange={(e) => {
												handlePayroll('payrollMobile', e.target.value.replace(/[^0-9]/g, ''));
												autoFilled && handleHr('hrMobile', e.target.value.replace(/[^0-9]/g, ''));
											}}
										/>
									</div>
								</div>
							</div>
							<div>
								<TextComponent className="errorText">{errorMsgList.payrollMobilerr}</TextComponent>
							</div>
						</div>
					</Form.Item>

					<Form.Item type="number" name="Landline">
						<div className="global_input_Container">
							<Input
								name="Landline"
								maxLength={13}
								onBlur={validateForm}
								type="text"
								labels={<span>Landline</span>}
								value={payrollLandline}
								// onChange={(e) => setPayrollLandline(e.target.value.replace(/[^0-9]/g, ''))}
								onChange={(e) => {
									handlePayroll('payrollLandline', e.target.value.replace(/[^0-9]/g, ''));
									autoFilled && handleHr('hrLandline', e.target.value.replace(/[^0-9]/g, ''));
								}}
							/>
							<div>
								<TextComponent className="errorText">{errorMsgList.payrollLandlineerr}</TextComponent>
							</div>
						</div>
					</Form.Item>
					<Form.Item type="email" name="payrollEmail">
						<Input
							name="payrollEmail"
							maxLength={100}
							onBlur={validateForm}
							type="email"
							labels={
								<span>
									Email ID <text style={{ color: 'red' }}>*</text>
								</span>
							}
							// onChange={(e) => setPayrollEmail(e.target.value)}
							value={payrollEmail}
							onChange={(e) => {
								handlePayroll('payrollEmail', e.target.value);
								autoFilled && handleHr('hrEmail', e.target.value);
							}}
						/>
						<div>
							<TextComponent className="errorText">{errorMsgList.payRollEmailerr}</TextComponent>
						</div>
					</Form.Item>
					<div className="headercontainer">
						<TextComponent className="heading_2_text">Main HR Contact</TextComponent>
						<TextComponent className="text2" style={{ marginTop: '10px' }}>
							<p>Second point of contact in case we cannot reach your main contact.</p>
						</TextComponent>
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
							<SalesForceCheckBox
								isDisabled={isDisabled}
								setIsDisabled={setIsDisabled}
								onCheck={copyMainPayRollDetails}
								text={'Check here if your main payroll contact is also your HR contact'}></SalesForceCheckBox>
						</div>
					</div>

					<div className="hrcontact_container" style={{ opacity: autoFilled ? '0.5' : null }}>
						<Form.Item
							validateTrigger="onBlur"
							rules={[
								{
									required: true,
									message: '',
								},
							]}>
							<Input
								disabled={isDisabled}
								type="text"
								onBlur={validateForm}
								labels={
									<span>
										Name <text style={{ color: 'red' }}>*</text>
									</span>
								}
								value={hrName}
								onChange={(e) => handleHr('hrName', e.target.value.replace(/[^A-Za-z ]/gi, ''))}
							/>
						</Form.Item>
						<Form.Item name="hrMobileNumber">
							<div style={{ display: 'flex', flexDirection: 'column' }}>
								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
									<div className="country_container">
										<img className="countryFlag" src={images.UAE} />
										<div className="countrycode" style={{ width: 'max-content', paddingRight: 20 }}>
											<TextComponent className="contact_no_text">+971 5</TextComponent>
										</div>
									</div>
									<div className="contact_container" style={{ width: '-webkit-fill-available' }}>
										<div className="global_input_Container">
											<Input
												disabled={isDisabled}
												name="hrMobileNumber"
												type="text"
												maxLength={8}
												onBlur={validateForm}
												labels={
													<span>
														Mobile Number <text style={{ color: 'red' }}>*</text>
													</span>
												}
												style={{ width: '300px !important' }}
												value={hrMobile}
												// onChange={(e) => setHrMobile(e.target.value.replace(/[^0-9]/g, ''))}
												onChange={(e) => handleHr('hrMobile', e.target.value.replace(/[^0-9]/g, ''))}
											/>
										</div>
									</div>
								</div>
								<div>
									<TextComponent className="errorText">{errorMsgList.hrMobileerr}</TextComponent>
								</div>
							</div>
						</Form.Item>
						<Form.Item name="hrLandline">
							<div className="global_input_Container">
								<Input
									disabled={isDisabled}
									name="hrLandline"
									maxLength={8}
									onBlur={validateForm}
									type="text"
									labels={<span>Landline</span>}
									value={hrLandline}
									// onChange={(e) => setHrLandline(e.target.value.replace(/[^0-9]/g, ''))}
									onChange={(e) => handleHr('hrLandline', e.target.value.replace(/[^0-9]/g, ''))}
								/>
								<div>
									<TextComponent className="errorText">{errorMsgList.hrLandlineer}</TextComponent>
								</div>
							</div>
						</Form.Item>
						<Form.Item name="hrEmail">
							<div className="global_input_Container">
								<Input
									disabled={isDisabled}
									name="hrEmail"
									type="text"
									onBlur={validateForm}
									labels={
										<span>
											Email ID <text style={{ color: 'red' }}>*</text>
										</span>
									}
									value={hrEmail}
									// onChange={(e) => setHrEmail(e.target.value)}
									onChange={(e) => handleHr('hrEmail', e.target.value)}
								/>
								<div>
									<TextComponent className="errorText">{errorMsgList.hrEmailerr}</TextComponent>
								</div>
							</div>
						</Form.Item>
					</div>
				</Form>
				{additionalDocuments.map(({ index, hrNameProp, hrMobileProp, hrLandlineProp, hrEmailProp }, i) => (
					<AdditionalContacts
						navigateDisabled={navigateDisabled}
						key={i}
						removeContact={removeAdditionalDocuments}
						{...{ index, hrNameProp, hrMobileProp, hrLandlineProp, hrEmailProp, handleValueChange }}
					/>
				))}

				<div className="addbtn">
					<button className="btn-add-contact" onClick={handleAddDocuments}>
						<span style={{ marginRight: '15px', fontSize: '20px', fontWeight: '300' }}>+</span> Add Additional Contacts
					</button>
				</div>
				<StepButton
					loading={savingData}
					disabled={!isAdditionalContactsValid || !isPayrollContactsValid || !isHrContactsValid || errorMsgList.payrollLandlineerr !== ''}
					onClick={() => handleSubmit(payrollObj, hrObj, additionalDocuments)}
					buttonText={'Next'}
				/>
			</Col>
		</>
	);
};
export default ContactInfoPresentational;
